import messageResource from '../../messageResource'
import UserListConfirmationConstants from './UserListConfirmationConstants'
import $ from 'jquery'

function UserListConfirmation() { this.constructor = UserListConfirmation; }

UserListConfirmation.prototype.WANT_TO_PROCEED_MESSAGE = messageResource.getMessage('userlist.js.confirmation.want_to_proceed');

UserListConfirmation.prototype.messageKeysMap = {};
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.LAST_APPROVER_DISABLED] = EnabledFeatures.APWSD ? "userlist.js.confirmation.last_approver_disabled.wsd_feature_on" : "userlist.js.confirmation.last_approver_disabled";
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.LAST_APPROVER_RIGHT_REVOKED] = "userlist.js.confirmation.last_approver_right_revoked";
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.LAST_OTHER_PRODUCT_APPROVER_DISABLED] = "userlist.js.confirmation.last_other_product_approver_disabled";
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.LAST_APPROVER_DELETED] = EnabledFeatures.APWSD ? "userlist.js.confirmation.last_approver_deleted.wsd_feature_on" : "userlist.js.confirmation.last_approver_deleted";
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.LAST_OTHER_PRODUCT_APPROVER_DELETED] = "userlist.js.confirmation.last_other_product_approver_deleted";
UserListConfirmation.prototype.messageKeysMap[UserListConfirmationConstants.HAS_LEAVE_REQUESTS] = "userlist.js.confirmation.requests_exist";

// no extension. same messages
UserListConfirmation.prototype.messageKeysMapIfDisabledDueToHDInThisProduct = $.extend({}, UserListConfirmation.prototype.messageKeysMap);

UserListConfirmation.prototype._createConfirmationMsg = function(confirmationException, msgKeyMap) {
    const codes = confirmationException.confirmationCodes;

    const length = codes.length;
    const confirmationMessages = [];

    for (let i = 0; i < length; i++) {
        confirmationMessages[i] = messageResource.getMessage(msgKeyMap[codes[i]]);
    }

    confirmationMessages.push(this.WANT_TO_PROCEED_MESSAGE);

    return confirmationMessages.join('\n\n');
};

UserListConfirmation.prototype.createEditConfirmationMsg = function(confirmationException) {
    return this._createConfirmationMsg(confirmationException, this.messageKeysMap);
};

UserListConfirmation.prototype.createDeleteConfirmationMsg = function(confirmationException) {
    return this._createConfirmationMsg(confirmationException, this.messageKeysMap);
};

export default UserListConfirmation



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/UserListConfirmation.js